<template>
	<v-dialog v-model="show" max-width="700px" persistent>
		<v-card>
			<v-toolbar elevation="0" color="grey lighten-4">
				<v-toolbar-title>Hồ sơ người dùng</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon @click="close">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-card-text style="max-height: 70vh; overflow-y: auto;">
				<v-tabs color="blue darken-2" v-model="tab">
					<v-tab href="#general">
						<span class="text-black text-none">Thông tin chung</span>
					</v-tab>
					<v-tab href="#role">
						<span class="text-black text-none">Phân quyền</span>
					</v-tab>
					<v-tab href="#leave">
						<span class="text-black text-none">Số dư ngày phép</span>
					</v-tab>
					<v-tab href="#password">
						<span class="text-black text-none">Đổi mật khẩu</span>
					</v-tab>
				</v-tabs>
				<v-divider></v-divider>
				<v-tabs-items v-model="tab" class="mt-4">
					<!-- General Info -->
					<v-tab-item value="general">
						<v-form ref="profileForm">
							<div class="section-title">Thông tin cơ bản</div>
							<v-row>
								<v-col cols="12" md="6">
									<v-text-field
										v-model="editableData.fullName"
										:rules="[rules.required]"
										outlined
										dense
									>
										<template #label>
											{{ $t('label.full_name') }} <span class="red--text">*</span>
										</template>
									</v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field
										:value="userInfo.userName"
										outlined
										dense
										readonly
										:label="$t('label.user_name')"
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" md="6">
									<v-text-field
										v-model="editableData.email"
										:rules="[rules.required, rules.email]"
										outlined
										dense
									>
										<template #label>
											{{ $t('label.email') }} <span class="red--text">*</span>
										</template>
									</v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field
										v-model="editableData.mobilePhone"
										outlined
										dense
										:label="$t('label.mobile_phone')"
									></v-text-field>
								</v-col>
							</v-row>
							<div class="section-title">Công tác</div>
							<v-row>
								<v-col cols="12" md="6">
									<v-text-field
										:value="organizationName"
										outlined
										dense
										readonly
										:label="$t('label.organize_use')"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field
										:value="rankName"
										outlined
										dense
										readonly
										:label="$t('label.rank')"
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" md="6">
									<v-text-field
										:value="userInfo.jobPosition"
										outlined
										dense
										readonly
										:label="$t('label.job_position')"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field
										:value="joinDateDisplay"
										outlined
										dense
										readonly
										label="Ngày vào ngành"
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" md="6">
									<v-text-field
										v-model="editableData.cnnNumber"
										outlined
										dense
										readonly
										:label="$t('label.cnnNumber')"
									></v-text-field>
								</v-col>
							</v-row>
							<div class="section-title">Thông tin cá nhân</div>
							<v-row>
								<v-col cols="12" md="6">
									<v-text-field
										v-model="editableData.identification"
										outlined
										dense
										:label="$t('label.identification')"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field
										v-model="editableData.issuseOrg"
										outlined
										dense
										:label="$t('label.issue_org')"
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" md="6">
									<v-text-field
										:value="dateOfBirthDisplay"
										outlined
										dense
										readonly
										label="Ngày sinh"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field
										v-model="editableData.hometown"
										outlined
										dense
										readonly
										:label="$t('label.hometown')"
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" md="6">
									<v-text-field
										v-model="editableData.businessPhones"
										outlined
										dense
										:label="$t('label.numberphone')"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field
										v-model="editableData.contactAddress"
										outlined
										dense
										:label="$t('label.contact_address')"
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" md="6">
									<v-text-field
										v-model="editableData.address"
										outlined
										dense
										:label="$t('label.address')"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="6">
									<v-text-field
										v-model="editableData.fax"
										outlined
										dense
										:label="$t('label.fax')"
									></v-text-field>
								</v-col>
							</v-row>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="blue darken-2" dark @click="saveProfile">
									Lưu thay đổi
								</v-btn>
							</v-card-actions>
						</v-form>
					</v-tab-item>

					<!-- Role Info (read-only) -->
					<v-tab-item value="role">
						<v-row>
							<v-col cols="12">
								<v-list style="margin-top: -24px">
									<v-list-item v-for="role in userInfo.roles" :key="role.id">
										<v-list-item-icon>
											<v-icon>mdi-shield-account</v-icon>
										</v-list-item-icon>
										<v-list-item-content>
											<v-list-item-title>{{ role.roleName }}</v-list-item-title>
											<v-list-item-subtitle>{{ role.roleCode }}</v-list-item-subtitle>
										</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-col>
						</v-row>
					</v-tab-item>

					<!-- Leave Balance -->
					<v-tab-item value="leave">
						<div class="leave-tab-content">
							<v-row class="mb-2 leave-fund-header-row">
								<v-col cols="12" sm="6">
									<v-select
										v-model="leaveYear"
										:items="leaveYearOptions"
										outlined
										dense
										hide-details
										label="Năm"
										@change="loadLeaveFund"
									></v-select>
								</v-col>
								<v-col v-if="!leaveEmpty" cols="12" sm="6">
									<v-text-field
										:value="leaveValueDisplay(totalLeft)"
										outlined
										dense
										readonly
										hide-details
										label="Tổng số ngày phép còn lại"
										class="leave-fund-total-field"
									></v-text-field>
								</v-col>
							</v-row>
							<v-row v-if="leaveError">
								<v-col cols="12">
									<v-alert type="warning" border="left" colored-border dense>
										{{ leaveError }}
									</v-alert>
								</v-col>
							</v-row>
							<v-row v-if="leaveEmpty">
								<v-col cols="12">
									<v-alert type="info" border="left" colored-border dense>
										Chưa có dữ liệu quỹ phép cho năm {{ leaveYear }} (chưa được cấp phép).
									</v-alert>
								</v-col>
							</v-row>
							<template v-else>
								<div
									v-for="group in leaveStatGroups"
									:key="group.title"
									class="leave-fund-section"
								>
									<div class="leave-fund-section-title">{{ group.title }}</div>
									<v-row class="leave-fund-row">
										<v-col
											v-for="item in group.items"
											:key="item.label"
											cols="12"
											md="4"
										>
											<v-text-field
												:value="leaveValueDisplay(item.value)"
												:label="item.label"
												outlined
												dense
												readonly
												hide-details
											></v-text-field>
										</v-col>
									</v-row>
								</div>
							</template>
						</div>
					</v-tab-item>

					<!-- Change Password -->
					<v-tab-item value="password">
						<v-form ref="changePasswordForm">
							<v-row>
								<v-col cols="12">
									<v-text-field
										v-model="oldPassword"
										:append-icon="showOld ? 'mdi-eye' : 'mdi-eye-off'"
										:type="showOld ? 'text' : 'password'"
										@click:append="showOld = !showOld"
										:rules="[rules.required]"
										outlined
										dense
										:label="$t('label.old_password') + ' *'"
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12">
									<v-text-field
										v-model="newPassword"
										:append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
										:type="showNew ? 'text' : 'password'"
										@click:append="showNew = !showNew"
										:rules="rules.password"
										outlined
										dense
										:label="$t('label.new_password') + ' *'"
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12">
									<v-text-field
										v-model="confirmPassword"
										:append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
										:type="showConfirm ? 'text' : 'password'"
										@click:append="showConfirm = !showConfirm"
										:rules="[
											...rules.password,
											(v) => v === this.newPassword || this.$t('label.password_not_match'),
										]"
										outlined
										dense
										:label="$t('label.re_password') + ' *'"
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12">
									<v-alert type="info" border="left" colored-border dense>
										{{ $t('label.password_requirement') }}
									</v-alert>
								</v-col>
							</v-row>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="blue darken-2" dark @click="changePassword">
									{{ $t('label.change_password') }}
								</v-btn>
							</v-card-actions>
						</v-form>
					</v-tab-item>
				</v-tabs-items>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import globalService from "@/services/global.service";
import administratorAPI from "@/views/modules/administrator/administrator.api";
import leaveFundService, {
	LEAVE_FUND_FIRST_TRACKED_YEAR,
} from "@/services/leave-fund.service";
import store from "@/store";
import moment from "moment";

export default {
	name: "UserProfileDialog",
	props: {
		value: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			tab: "general",
			oldPassword: "",
			newPassword: "",
			confirmPassword: "",
			showOld: false,
			showNew: false,
			showConfirm: false,
			leaveYear: new Date().getFullYear(),
			leaveFund: {
				carryoverTotal: 0,
				carryoverLeft: 0,
				annualTotal: 0,
				annualUsed: 0,
				annualLeft: 0,
			},
			leaveEmpty: false,
			leaveError: "",
			editableData: {
				fullName: "",
				email: "",
				mobilePhone: "",
				businessPhones: "",
				fax: "",
				address: "",
				contactAddress: "",
				identification: "",
				cnnNumber: "",
				hometown: "",
				issuseOrg: "",
			},
			rules: {
				required: (v) => !!v || "Trường này là bắt buộc",
				email: (v) => /.+@.+\..+/.test(v) || "Email không hợp lệ",
				password: [
					(v) => !!v || "Mật khẩu không được để trống",
					(v) => (v && v.length >= 8) || "Mật khẩu phải có ít nhất 8 ký tự",
					(v) => (v && v.length <= 50) || "Mật khẩu không được vượt quá 50 ký tự",
					(v) => (v && /[A-Z]/.test(v)) || "Mật khẩu phải có ít nhất 1 chữ hoa",
					(v) => (v && /[a-z]/.test(v)) || "Mật khẩu phải có ít nhất 1 chữ thường",
					(v) => (v && /[0-9]/.test(v)) || "Mật khẩu phải có ít nhất 1 chữ số",
					(v) => (v && !/^[a-zA-Z0-9]+$/.test(v)) || "Mật khẩu phải có ít nhất 1 ký tự đặc biệt",
				],
			},
		};
	},
	computed: {
		show: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
		userInfo() {
			return store.state.currentUserInfo || {};
		},
		organizationName() {
			if (this.userInfo.organizations && this.userInfo.organizations.length > 0) {
				return this.userInfo.organizations.map((o) => o.organizationName).join(", ");
			}
			return "";
		},
		rankName() {
			if (this.userInfo.ranks && this.userInfo.ranks.length > 0) {
				return this.userInfo.ranks.map((r) => r.rankName).join(", ");
			}
			return "";
		},
		// Ngày vào ngành: chỉ hiển thị (read-only) trên hồ sơ người dùng; sửa ở màn quản lý người dùng.
		joinDateDisplay() {
			const value = this.userInfo.joinDate;
			if (!value) {
				return "";
			}
			const d = moment(value);
			return d.isValid() ? d.format("DD/MM/YYYY") : "";
		},
		// Ngày sinh: chỉ hiển thị (read-only) trên hồ sơ người dùng; sửa ở màn quản lý người dùng.
		dateOfBirthDisplay() {
			const value = this.userInfo.dateOfBirth;
			if (!value) {
				return "";
			}
			const d = moment(value);
			return d.isValid() ? d.format("DD/MM/YYYY") : "";
		},
		// Danh sách năm để chọn: từ năm go-live (annual-leave.first-tracked-year ở
		// backend) đến năm hiện tại — lấy năm hiện tại làm chuẩn nên sang năm sau
		// (VD 2027) danh sách tự trượt theo, không cần sửa lại hard-code.
		leaveYearOptions() {
			const current = new Date().getFullYear();
			const years = [];
			for (let y = current; y >= LEAVE_FUND_FIRST_TRACKED_YEAR; y--) {
				years.push(y);
			}
			return years.length ? years : [current];
		},
		/**
		 * Số phép tồn đã dùng = carryoverTotal - carryoverLeft (backend chưa expose
		 * trực tiếp trường này qua DTO chi tiết, suy ra từ 2 giá trị đã có, đồng nhất
		 * với cách tính ở màn quản lý quỹ phép — LeaveFundList.vue#carryoverUsedOf).
		 */
		carryoverUsed() {
			const used = this.toNumber(this.leaveFund.carryoverTotal) - this.toNumber(this.leaveFund.carryoverLeft);
			return used > 0 ? used : 0;
		},
		/** Tổng số phép còn lại (phép tồn + phép năm). */
		totalLeft() {
			return this.toNumber(this.leaveFund.carryoverLeft) + this.toNumber(this.leaveFund.annualLeft);
		},
		leaveStatGroups() {
			return [
				{
					title: "Phép tồn",
					items: [
						{ label: "Tổng", value: this.leaveFund.carryoverTotal },
						{ label: "Đã dùng", value: this.carryoverUsed },
						{ label: "Còn lại", value: this.leaveFund.carryoverLeft },
					],
				},
				{
					title: "Phép năm",
					items: [
						{ label: "Tổng", value: this.leaveFund.annualTotal },
						{ label: "Đã dùng", value: this.leaveFund.annualUsed },
						{ label: "Còn lại", value: this.leaveFund.annualLeft },
					],
				},
			];
		},
	},
	watch: {
		show(val) {
			if (val) {
				this.tab = "general";
				this.oldPassword = "";
				this.newPassword = "";
				this.confirmPassword = "";
				this.leaveYear = new Date().getFullYear();
				this.resetLeaveFund();
				this.initEditableData();
			} else {
				this.resetFormValidation();
			}
		},
		tab(val) {
			this.resetFormValidation();
			if (val === "leave") {
				this.loadLeaveFund();
			}
		},
	},
	methods: {
		close() {
			this.show = false;
		},
		resetFormValidation() {
			this.$nextTick(() => {
				this.$refs.profileForm?.resetValidation();
				this.$refs.changePasswordForm?.resetValidation();
			});
		},
		resetLeaveFund() {
			this.leaveFund = {
				carryoverTotal: 0,
				carryoverLeft: 0,
				annualTotal: 0,
				annualUsed: 0,
				annualLeft: 0,
			};
			this.leaveEmpty = false;
			this.leaveError = "";
		},
		toNumber(value) {
			if (value === null || value === undefined || value === "") {
				return 0;
			}
			const num = Number(value);
			return Number.isFinite(num) ? num : 0;
		},
		/**
		 * Hiển thị giá trị phép dạng chuỗi. Các ô này chỉ được render khi ĐÃ có bản
		 * ghi quỹ phép (xem `v-else` trong template ứng với `leaveEmpty`) — nhờ đó
		 * "0" hiển thị luôn là giá trị thật (ví dụ đã dùng = 0), không còn bị nhầm
		 * với trường hợp chưa có dữ liệu (trường hợp đó chỉ hiện alert, không hiện số).
		 */
		leaveValueDisplay(value) {
			return `${this.toNumber(value)}`;
		},
		async loadLeaveFund() {
			const userId = this.userInfo.id;
			if (!userId) {
				this.resetLeaveFund();
				this.leaveError = "Không xác định được người dùng để tra cứu quỹ phép.";
				return;
			}
			this.leaveError = "";
			try {
				const data = await leaveFundService.detail(userId, this.leaveYear);
				if (data && (data.id || data.userId)) {
					this.leaveFund = {
						carryoverTotal: this.toNumber(data.carryoverTotal),
						carryoverLeft: this.toNumber(data.carryoverLeft),
						annualTotal: this.toNumber(data.annualTotal),
						annualUsed: this.toNumber(data.annualUsed),
						annualLeft: this.toNumber(data.annualLeft),
					};
					this.leaveEmpty = false;
				} else {
					this.resetLeaveFund();
					this.leaveEmpty = true;
				}
			} catch (error) {
				console.log(error);
				this.resetLeaveFund();
				this.leaveEmpty = true;
			}
			// Dữ liệu load xong làm DOM cao hơn lúc v-tabs-items đo chiều cao ban đầu;
			// ép Vuetify tính lại chiều cao container + label outlined.
			this.$nextTick(() => {
				window.dispatchEvent(new Event("resize"));
			});
		},
		initEditableData() {
			this.editableData.fullName = this.userInfo.fullName || "";
			this.editableData.email = this.userInfo.email || "";
			this.editableData.mobilePhone = this.userInfo.mobilePhone || "";
			this.editableData.businessPhones = this.userInfo.businessPhones || "";
			this.editableData.fax = this.userInfo.fax || "";
			this.editableData.address = this.userInfo.address || "";
			this.editableData.contactAddress = this.userInfo.contactAddress || "";
			this.editableData.identification = this.userInfo.identification || "";
			this.editableData.cnnNumber = this.userInfo.cnnNumber || "";
			this.editableData.hometown = this.userInfo.hometown || "";
			this.editableData.issuseOrg = this.userInfo.issuseOrg || "";
		},
		async saveProfile() {
			if (!this.$refs.profileForm.validate()) return;
			try {
				let response = await globalService.putData_Async(
					administratorAPI.API_UpdateCurrentUserInfo(),
					this.editableData,
				);
				if (response && response.state) {
					this.toastSuccess(this.$t("message.update_success"));
					store.commit("SET_CURRENT_USER_INFO", response.data);
				} else {
					this.toastError(response?.message || this.$t("message.update_error"));
				}
			} catch (error) {
				console.log(error);
				this.toastError(this.$t("message.update_error"));
			}
		},
		async changePassword() {
			if (!this.$refs.changePasswordForm.validate()) return;
			try {
				let response = await globalService.postData_Async(
					administratorAPI.API_ChangePassword(),
					{
						oldPassword: this.oldPassword,
						newPassword: this.newPassword,
					},
				);
				if (response && response.state) {
					this.toastSuccess("Đổi mật khẩu thành công");
					this.oldPassword = "";
					this.newPassword = "";
					this.confirmPassword = "";
					this.tab = "general";
				} else {
					this.toastError(response?.message || "Đổi mật khẩu thất bại");
				}
			} catch (error) {
				console.log(error);
				this.toastError("Lỗi khi đổi mật khẩu");
			}
		},
	},
};
</script>

<style scoped>
/*
 * v-tabs-items (v-window) cố định height theo tab active lúc chuyển tab;
 * khi tab "Số dư ngày phép" load thêm nội dung async, height cũ cắt mất phần dưới.
 */
::v-deep .v-window__container {
	height: auto !important;
	min-height: 0;
	overflow: visible;
	padding-top: 14px;
}
::v-deep .v-window-item {
	overflow: visible;
}
::v-deep .col-md-6,
::v-deep .col-12,
::v-deep .col {
	padding-top: 4px !important;
	padding-bottom: 4px !important;
}

.section-title {
	font-size: 1rem;
	font-weight: 500;
	color: #1976d2;
	margin-top: 8px;
	margin-bottom: 20px;
	padding-bottom: 6px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.section-title:first-child {
	margin-top: -8px;
}
.section-title:not(:first-child) {
	margin-top: 20px;
}

.leave-tab-content {
	padding-bottom: 16px;
}
.leave-fund-section {
	margin-top: 16px;
	margin-bottom: 24px;
}
.leave-fund-section:first-child {
	margin-top: 8px;
}
::v-deep .leave-fund-header-row .col {
	padding-top: 8px !important;
	padding-bottom: 8px !important;
}
.leave-fund-section-title {
	display: block;
	font-size: 0.8125rem;
	font-weight: 700;
	line-height: 1.4;
	color: rgba(0, 0, 0, 0.6);
	margin-bottom: 16px;
}

/* Khoảng trống phía trên ô outlined để label không đè lên title nhóm. */
::v-deep .leave-fund-row .col {
	padding-top: 12px !important;
	padding-bottom: 8px !important;
}
::v-deep .leave-fund-total-field.v-text-field--outlined > .v-input__control > .v-input__slot {
	background: rgba(25, 118, 210, 0.04);
}
::v-deep .leave-fund-total-field fieldset {
	border-color: rgba(25, 118, 210, 0.55);
	border-width: 1.5px;
}
::v-deep .leave-fund-total-field label {
	color: rgba(21, 101, 192, 0.92) !important;
	font-weight: 600;
}
</style>
